export const getAnalyticsUrl = (string: string) => `/analytics${string}`
export const getNewsUrl = (string: string) => `/news${string}`
export const getSchoolUrl = (string: string) => `/school${string}`
export const getShopUrl = (string: string) => `/shop${string}`
export const getUserUrl = (string: string) => `/user${string}`
export const getSportUrl = (string: string) => `/sport${string}`
export const getGameUrl = (string: string) => `/game/${string}`
export const getStatisticUrl = (string: string) => `/stats${string}`
export const getChatUrl = (string: string) => `/chat${string}`
